const EmptyCell = ({ start, end, room }) => {
  return (
    <td className={`empty room${room.number}`} start={start} rowSpan="3"></td>
  );
};

export default EmptyCell;
